import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import FallbackContent from './FallbackContent';
import { AppBar } from './alf-design';
import { Background, Footer } from './layout';

const Fallback = ({ resetErrorBoundary }) => {
  const recoverTo = (path) => {
    window.history.replaceState(null, '', path);
    resetErrorBoundary();
  };

  return (
    <BrowserRouter>
      <Background>
        <AppBar
          onHelp={() => recoverTo('/help')}
          onUserProfile={() => recoverTo('/user-profile')}
          onHome={() => recoverTo('/')}
        />
        <main
          id="error-main-content"
          role="main"
          className="flex flex-col items-center justify-center min-h-[60vh]"
        >
          <FallbackContent />
        </main>
        <Footer maxWidth bgWhite />
      </Background>
    </BrowserRouter>
  );
};

const ErrorBoundary = (props) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={Fallback}
      onError={(error, info) => {
        console.error('[ErrorBoundary] Caught error:', error);
        console.error('[ErrorBoundary] Component stack:', info?.componentStack);
      }}
    >
      {props.children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
